import { render } from "./LinksPanel.vue?vue&type=template&id=4ca43f27&scoped=true&ts=true"
import script from "./LinksPanel.vue?vue&type=script&lang=ts"
export * from "./LinksPanel.vue?vue&type=script&lang=ts"

import "./LinksPanel.vue?vue&type=style&index=0&id=4ca43f27&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/jobs/RECA/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca43f27"]])

export default __exports__